import type { FaireProductEntity } from "../../entity_types/product";

export const default_3: FaireProductEntity = {
  token: "default-3",
  type: "product",
  name: "Extra Virgin Olive Oil - 500ml",
  brandName: "Olive Grove Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5f2ab75c67c3c46db324f3e8ed776d2a6f9ab95710a461dd3e636730314726d9.webp",
  priceDollars: 16.75,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
